import localhost from "apis/localhost";
import { extractLockedByUser } from "apis/utils";
import { showErrorModal } from "slices/app/actions/error";
import {
  addToJobQueue,
  disableNavBarAndSideBar,
  removeFromJobQueue,
} from "slices/app/appSlice";

import { setIsLocked } from "../outlineSlice";
import { ERROR_TITLE, getOwnerUrl } from "./shared";

const JOB_QUEUE_LOCK_TASK = "toggleProposalOutlineLocking";

const toggleLocked = (dispatch, params = {}) => {
  const lockedBySelf = Boolean(params.lockedByCurrentUser);
  dispatch(setIsLocked(params));
  dispatch(disableNavBarAndSideBar(lockedBySelf));
};

export const lockEditing = (ownerType, ownerId) => async (dispatch) => {
  dispatch(addToJobQueue(JOB_QUEUE_LOCK_TASK));

  try {
    const rsp = await localhost.post(`${getOwnerUrl(ownerType, ownerId)}/lock`);
    toggleLocked(dispatch, rsp.data);
    return true;
  } catch (error) {
    if (error.status === 423) {
      const lockedBy = extractLockedByUser(error);
      const params = { locked: true, lockedBy, lockedByCurrentUser: false };
      toggleLocked(dispatch, params);
    } else {
      dispatch(showErrorModal(error, ERROR_TITLE));
    }
    return false;
  } finally {
    dispatch(removeFromJobQueue(JOB_QUEUE_LOCK_TASK));
  }
};

export const unlockEditing = (ownerType, ownerId) => async (dispatch) => {
  dispatch(addToJobQueue(JOB_QUEUE_LOCK_TASK));
  try {
    await localhost.post(`${getOwnerUrl(ownerType, ownerId)}/unlock`);
    toggleLocked(dispatch);
  } catch (error) {
    dispatch(showErrorModal(error, ERROR_TITLE));
  } finally {
    dispatch(removeFromJobQueue(JOB_QUEUE_LOCK_TASK));
  }
};

// The lock's TTL runs from the last heartbeat, so an edit that outlasts it silently loses the lock
// while the UI still believes it holds one — the save then fails. Deliberately quiet: a missed beat
// is recoverable on the next one, and an expired lock already surfaces on save.
export const sendLockHeartbeat = (ownerType, ownerId) => async () => {
  try {
    await localhost.post(`${getOwnerUrl(ownerType, ownerId)}/heartbeat`);
  } catch (error) {
    console.warn("Outline lock heartbeat failed", error?.message ?? error);
  }
};
